import { inject, Injectable } from '@angular/core';
import { MandatoryField, MandatoryFieldsApiService } from '@vdms-hq/api-contract';
import { BehaviorSubject, Observable, of, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MandatoryFieldsFetcherService {
  private mandatoryFieldsApiService = inject(MandatoryFieldsApiService);

  private readonly refresh$ = new BehaviorSubject<boolean>(false);
  private readonly _loading$ = new BehaviorSubject<boolean>(false);

  readonly loading$ = this._loading$.asObservable();

  readonly mandatoryFields$: Observable<MandatoryField[]> = this.refresh$.pipe(
    switchMap((shouldFetch) => {
      if (!shouldFetch) {
        return of([]);
      }
      this._loading$.next(true);
      return this.mandatoryFieldsApiService.getMandatoryFields().pipe(tap(() => this._loading$.next(false)));
    }),
    shareReplay(1),
  );

  reset(): void {
    this.refresh$.next(false);
  }

  fetch(): void {
    this.refresh$.next(true);
  }
}
